export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">At BoostedPins, we take your privacy seriously. This policy describes how we collect, use, and protect your personal information.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">1. Information We Collect</h2>
      <p className="mb-4">We collect information you provide directly to us, such as when you create an account, subscribe to our service, or contact us for support. This may include your name, email address, and payment information.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">2. How We Use Your Information</h2>
      <p className="mb-4">We use your information to provide, maintain, and improve our services, process transactions, send you technical notices and support messages, and respond to your comments and questions.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">3. Third-Party Services and APIs</h2>
      <p className="mb-4">We integrate with Shopify and Pinterest through their official APIs to provide our services. By using our platform, you acknowledge and agree that:</p>
      <ul className="list-disc ml-8 mb-4">
        <li className="mb-2">We will request access to your Shopify and Pinterest accounts through official authentication methods</li>
        <li className="mb-2">Any actions involving your Shopify or Pinterest accounts will require your explicit approval</li>
        <li className="mb-2">You agree not to use our platform in ways that violate Shopify's or Pinterest's terms of service</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">4. Information Sharing and Security</h2>
      <p className="mb-4">We do not sell or share your personal information with third parties, except as necessary to provide our services or comply with legal obligations. We implement appropriate technical and organizational measures to protect your data.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">5. Your Rights and Choices</h2>
      <p className="mb-4">You have the right to access, correct, or delete your personal information. You can also opt out of certain data collection and use practices.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">6. Cookies and Similar Technologies</h2>
      <p className="mb-4">We use cookies and similar tracking technologies to collect information about your browsing activities on our website. You can control cookies through your browser settings.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">7. Changes to This Policy</h2>
      <p className="mb-4">We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">8. Contact Us</h2>
      <p className="mb-4">If you have any questions about this privacy policy, please contact us!</p>
      
      <p className="mt-8">Last updated: 2024-12-20</p>
    </div>
  )
}

